export const statesData = {
  Karnataka: {
    Bagalkot: ["Bagalkot", "Badami", "Jamkhandi", "Mudhol"],
  Ballari: ["Ballari", "Hospet", "Kudligi", "Sandur"],
  Belagavi: ["Belagavi", "Athani", "Chikkodi", "Gokak", "Khanapur"],
  BengaluruUrban: ["Bengaluru", "Yelahanka", "KR Puram", "Whitefield"],
  BengaluruRural: ["Devanahalli", "Doddaballapur", "Hosakote", "Nelamangala"],
  Bidar: ["Bidar", "Basavakalyan", "Bhalki", "Aurad"],
  Vijayapura: ["Vijayapura", "Indi", "Sindagi", "Muddebihal"],
  Chamarajanagar: ["Chamarajanagar", "Kollegal", "Yelandur", "Hanur"],
  Chikkaballapur: ["Chikkaballapur", "Sidlaghatta", "Bagepalli", "Gauribidanur"],
  Chikkamagaluru: ["Chikkamagaluru", "Tarikere", "Kadur", "Mudigere"],
  Chitradurga: ["Chitradurga", "Hosadurga", "Hiriyur", "Molakalmuru"],
  DakshinaKannada: ["Mangaluru", "Bantwal", "Puttur", "Sullia"],
  Davanagere: ["Davanagere", "Harihar", "Honnali", "Channagiri"],
  Dharwad: ["Dharwad", "Hubballi", "Kalghatgi", "Navalgund"],
  Gadag: ["Gadag", "Mundaragi", "Nargund", "Shirahatti"],
  Kalaburagi: ["Kalaburagi", "Afzalpur", "Chincholi", "Sedam"],
  Hassan: ["Hassan", "Arsikere", "Belur", "Channarayapatna"],
  Haveri: ["Haveri", "Ranebennur", "Byadgi", "Hirekerur"],
  Kodagu: ["Madikeri", "Somwarpet", "Virajpet"],
  Kolar: ["Kolar", "Malur", "Mulbagal", "Bangarpet"],
  Koppal: ["Koppal", "Gangavati", "Kushtagi", "Yelburga"],
  Mandya: ["Mandya", "Maddur", "Srirangapatna", "Nagamangala"],
  Mysuru: ["Mysuru", "Nanjangud", "Hunsur", "T Narasipura"],
  Raichur: ["Raichur", "Sindhanur", "Manvi", "Lingasugur"],
  Ramanagara: ["Ramanagara", "Kanakapura", "Channapatna", "Magadi"],
  Shivamogga: ["Shivamogga", "Bhadravati", "Sagar", "Tirthahalli"],
  Tumakuru: ["Tumakuru", "Sira", "Tiptur", "Gubbi"],
  Udupi: ["Udupi", "Kundapura", "Karkala"],
  UttaraKannada: ["Karwar", "Sirsi", "Ankola", "Bhatkal"],
  Vijayanagara: ["Hospet", "Kudligi", "Hagaribommanahalli"],
  Yadgir: ["Yadgir", "Shorapur", "Gurumitkal"]
  },
    // ✅ add all other districts + towns here
  Assam: {
    Kamrup: ["Guwahati", "Dispur", "North Guwahati"],
    Dibrugarh: ["Dibrugarh", "Moranhat", "Naharkatia"],
    Silchar: ["Silchar", "Lakhipur", "Sonai"],
    Jorhat: ["Jorhat", "Mariani", "Titabor"],
    Nagaon: ["Nagaon", "Dhing", "Kaliabor"],
  },
  Bihar: {
    Patna: ["Patna", "Danapur", "Phulwari Sharif"],
    Gaya: ["Gaya", "Bodh Gaya", "Sherghati"],
    Muzaffarpur: ["Muzaffarpur", "Motipur", "Kanti"],
    Bhagalpur: ["Bhagalpur", "Naugachhia", "Sultanganj"],
    Darbhanga: ["Darbhanga", "Benipur", "Bahera"],
  },
  Chhattisgarh: {
    Raipur: ["Raipur", "Birgaon", "Tilda Newra"],
    Bhilai: ["Bhilai", "Durg", "Charoda"],
    Bilaspur: ["Bilaspur", "Ratanpur", "Kota"],
    Korba: ["Korba", "Katghora", "Deepka"],
  },
  Goa: {
    NorthGoa: ["Panaji", "Mapusa", "Bicholim", "Calangute"],
    SouthGoa: ["Margao", "Vasco da Gama", "Ponda", "Canacona"],
  },
  Gujarat: {
    Ahmedabad: ["Ahmedabad", "Bavla", "Sanand", "Viramgam"],
    Surat: ["Surat", "Bardoli", "Vyara"],
    Vadodara: ["Vadodara", "Padra", "Karjan"],
    Rajkot: ["Rajkot", "Gondal", "Jetpur"],
    Bhavnagar: ["Bhavnagar", "Palitana", "Mahuva"],
  },
  Haryana: {
    Gurugram: ["Gurugram", "Manesar", "Sohna"],
    Faridabad: ["Faridabad", "Ballabhgarh", "Palwal"],
    Panipat: ["Panipat", "Samalkha", "Israna"],
    Ambala: ["Ambala City", "Ambala Cantt", "Naraingarh"],
    Rohtak: ["Rohtak", "Meham", "Kalanaur"],
  },
  HimachalPradesh: {
    Shimla: ["Shimla", "Rampur", "Theog"],
    Kangra: ["Dharamshala", "Palampur", "Kangra"],
    Mandi: ["Mandi", "Sundernagar", "Jogindernagar"],
    Kullu: ["Kullu", "Manali", "Banjar"],
  },
  Jharkhand: {
    Ranchi: ["Ranchi", "Bundi", "Khelari"],
    Jamshedpur: ["Jamshedpur", "Mango", "Jugsalai"],
    Dhanbad: ["Dhanbad", "Jharia", "Sindri"],
    Bokaro: ["Bokaro Steel City", "Chas", "Phusro"],
  },

  Kerala: {
    Thiruvananthapuram: ["Thiruvananthapuram", "Neyyattinkara", "Varkala"],
    Ernakulam: ["Kochi", "Aluva", "Perumbavoor"],
    Kozhikode: ["Kozhikode", "Vadakara", "Quilandy"],
    Thrissur: ["Thrissur", "Guruvayur", "Chalakudy"],
  },
  MadhyaPradesh: {
    Indore: ["Indore", "Mhow", "Depalpur"],
    Bhopal: ["Bhopal", "Bairagarh", "Berasia"],
    Gwalior: ["Gwalior", "Dabra", "Bhitarwar"],
    Jabalpur: ["Jabalpur", "Sihora", "Patan"],
    Ujjain: ["Ujjain", "Nagda", "Mahidpur"],
  },
  Maharashtra: {
    Mumbai: ["Mumbai", "Andheri", "Borivali", "Colaba"],
    Pune: ["Pune", "Pimpri-Chinchwad", "Hingewadi"],
    Nagpur: ["Nagpur", "Kamptee", "Kalmeshwar"],
    Thane: ["Thane", "Kalyan", "Dombivli", "Mira-Bhayandar"],
    Nashik: ["Nashik", "Malegaon", "Deolali"],
  },
  Manipur: {
    ImphalWest: ["Imphal", "Mayang Imphal", "Lamsang"],
    Churachandpur: ["Churachandpur", "Lamka", "Pherzawl"],
  },
  Meghalaya: {
    EastKhasiHills: ["Shillong", "Cherrapunji", "Mawsynram"],
    WestGaroHills: ["Tura", "Phulbari", "Dadenggre"],
  },
  Mizoram: {
    Aizawl: ["Aizawl", "Sairang", "Darlawn"],
    Lunglei: ["Lunglei", "Tlabung", "Hnahthial"],
  },
  Nagaland: {
    Kohima: ["Kohima", "Chiephobozou", "Tseminyu"],
    Dimapur: ["Dimapur", "Chumukedima", "Niuland"],
  },
  Odisha: {
    Khordha: ["Bhubaneswar", "Khordha", "Jatni"],
    Cuttack: ["Cuttack", "Choudwar", "Athagarh"],
    Ganjam: ["Berhampur", "Hinjilicut", "Chatrapur"],
    Sundargarh: ["Rourkela", "Sundargarh", "Biramitrapur"],
  },
  Punjab: {
    Amritsar: ["Amritsar", "Ajnala", "Baba Bakala"],
    Ludhiana: ["Ludhiana", "Khanna", "Jagraon"],
    Jalandhar: ["Jalandhar", "Nakodar", "Phillaur"],
    Patiala: ["Patiala", "Nabha", "Rajpura"],
  },
  Rajasthan: {
    Jaipur: ["Jaipur", "Chomu", "Amer", "Sanganer"],
    Jodhpur: ["Jodhpur", "Piparcity", "Bilara"],
    Udaipur: ["Udaipur", "Fatehnagar", "Salumbar"],
    Kota: ["Kota", "Sangod", "Ramganj Mandi"],
    Ajmer: ["Ajmer", "Beawar", "Kishangarh"],
  },
  Sikkim: {
    EastSikkim: ["Gangtok", "Singtam", "Rangpo"],
    WestSikkim: ["Gyalshing", "Pelling", "Nayabazar"],
  },
  TamilNadu: {
    Chennai: ["Chennai", "Adyar", "Ambattur", "Tambaram"],
    Coimbatore: ["Coimbatore", "Pollachi", "Mettupalayam"],
    Madurai: ["Madurai", "Melur", "Thiruparankundram"],
    Salem: ["Salem", "Mettur", "Attur"],
    Trichy: ["Tiruchirappalli", "Srirangam", "Manapparai"],
  },
  Telangana: {
    Hyderabad: ["Hyderabad", "Secunderabad", "Gachibowli"],
    Warangal: ["Warangal", "Hanamkonda", "Kazipet"],
    Nizamabad: ["Nizamabad", "Armoor", "Bodhan"],
    Karimnagar: ["Karimnagar", "Huzurabad", "Choppadandi"],
  },
  Tripura: {
    WestTripura: ["Agartala", "Ranirbazar", "Mohanpur"],
    SouthTripura: ["Belonia", "Santirbazar", "Sabroom"],
  },
  UttarPradesh: {
    Lucknow: ["Lucknow", "Malihabad", "Bakshi Ka Talab"],
    Kanpur: ["Kanpur", "Bilhaur", "Ghatampur"],
    Agra: ["Agra", "Fatehabad", "Etmadpur"],
    Varanasi: ["Varanasi", "Pindra", "Ramnagar"],
    Ghaziabad: ["Ghaziabad", "Loni", "Modinagar"],
    Prayagraj: ["Prayagraj", "Phulpur", "Handia"],
    Meerut: ["Meerut", "Sardhana", "Mawana"],
  },
  Uttarakhand: {
    Dehradun: ["Dehradun", "Mussoorie", "Rishikesh"],
    Haridwar: ["Haridwar", "Roorkee", "Laksar"],
    Nainital: ["Nainital", "Haldwani", "Ramnagar"],
  },
  WestBengal: {
    Kolkata: ["Kolkata", "Salt Lake", "Alipore"],
    North24Parganas: ["Bidhannagar", "Barrackpore", "Barasat"],
    South24Parganas: ["Baruipur", "Sonarpur", "Canning"],
    Howrah: ["Howrah", "Bally", "Uluberia"],
    Darjeeling: ["Darjeeling", "Kurseong", "Siliguri"],
  },
  // Union Territories
  Delhi: {
    NewDelhi: ["Connaught Place", "Chanakyapuri", "Lodhi Colony"],
    SouthDelhi: ["Saket", "Hauz Khas", "Mehrauli"],
    NorthDelhi: ["Civil Lines", "Rohini", "Model Town"],
  },
  JammuAndKashmir: {
    Srinagar: ["Srinagar", "Ganderbal", "Pampore"],
    Jammu: ["Jammu", "Akhnoor", "RS Pura"],
  },
  Ladakh: {
    Leh: ["Leh", "Nubra", "Khaltsi"],
    Kargil: ["Kargil", "Drass", "Zanskar"],
  },
  Puducherry: {
    Puducherry: ["Puducherry", "Oulgaret", "Ariyankuppam"],
    Karaikal: ["Karaikal", "Thirunallar"],
  },
  AndamanAndNicobar: {
    SouthAndaman: ["Port Blair", "Ferrargunj"],
    Nicobar: ["Car Nicobar", "Great Nicobar"],
  },
};